import axios from "axios";

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/signatureId`;

const create = (data) => axios.post(apiUrl, data);

const get = ({ signatureId }) => axios.get(`${apiUrl}/${signatureId}`);

const signatureIdService = {
  create,
  get,
};

export default signatureIdService;
